import React, { useEffect } from "react";
import notification from "antd/lib/notification";
import Form from "antd/lib/form";

function Step5({ setCurrStep, currStep, user_type, setPayload, payload }) {
  const [userForm] = Form.useForm();

  const onSubmit = async (values) => {
    const { twitter, linkedin, facebook, portfolio } = values;
    const socials = {
      twitter,
      linkedin,
      facebook,
      portfolio,
    };
    goNext(socials);
  };

  const goNext = (socials) => {
    setCurrStep(currStep + 1);
    setPayload({ ...payload, ...socials });
  };

  useEffect(() => {
    userForm.setFieldsValue(payload);
  }, []);

  return (
    <>
      <Form
        form={userForm}
        name="normal_login"
        layout="vertical"
        hideRequiredMark="true"
        className="login-form mt3"
      >
        <div className="w-full justify-between flex">
          <Form.Item name="twitter" className="!mb-0 w-1/2">
            <div className="w-full mb-4 mr-2">
              <label className="text-main">Twitter</label>
              <input
                data-testid="twitter_input"
                defaultValue={payload.twitter}
                className="main-input text-tint h-12 rounded-md w-full focus:outline-none px-3"
              />
            </div>
          </Form.Item>
          <Form.Item name="linkedin" className="!mb-0 w-1/2">
            <div className="w-full mb-4 ml-2">
              <label className="text-main">Linkedin</label>
              <input
                data-testid="linkedin_input"
                defaultValue={payload?.linkedin}
                className="main-input text-tint h-12 rounded-md w-full focus:outline-none px-3"
              />
            </div>
          </Form.Item>
        </div>

        <div className="w-full justify-between flex">
          <Form.Item name="facebook" className="!mb-0 w-1/2">
            <div className="w-full mb-4 mr-2">
              <label className="text-main">Facebook</label>
              <input
                data-testid="facebook_input"
                defaultValue={payload?.facebook}
                className="main-input text-tint h-12 rounded-md w-full focus:outline-none px-3"
              />
            </div>
          </Form.Item>

          <Form.Item name="medium" className="!mb-0 w-1/2">
            <div className="w-full mb-4 ml-2">
              <label className="text-main">Medium Link</label>
              <input
                data-testid="medium_input"
                defaultValue={payload?.medium}
                className="main-input text-tint h-12 rounded-md w-full focus:outline-none px-3"
              />
            </div>
          </Form.Item>
        </div>
      </Form>

      <div className="w-full justify-between flex mt-10 fixed bottom-0 left-0 bg-white [@media(min-width:987px)]:bg-transparent p-5 [@media(min-width:987px)]:p-0 border-neutral [@media(min-width:987px)]:border-0 border-y [@media(min-width:987px)]:relative z-10">
        <button
          onClick={() => setCurrStep(currStep - 1)}
          className="bg-pri-tint border-pri bw-1 px-5 py-3 rounded-lg pri w-1/2 mr-1"
        >
          Previous
        </button>

        <button
          data-testid="next_button"
          onClick={() => {
            let values = userForm.getFieldsValue();
            if (!Object.entries(values).filter(([k, v], i) => !!v).length) {
              notification.error({
                message: "Please enter at least one social link to proceed",
              });
              return;
            }
            if (user_type === "instructor") {
              onSubmit(values);
            } else {
              setPayload(values);
              setCurrStep(currStep + 1);
            }
          }}
          className="bg-pri px-5 py-3 rounded-lg text-white w-1/2 ml-1"
        >
          Next
        </button>
      </div>
    </>
  );
}

export default Step5;
